import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TaskService } from './task.service';
import { TasksListComponent } from './list/tasks-list.component';
import { CreateTaskComponent } from './create/create-task.component';

import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { AngularDateTimePickerModule } from 'angular2-datetimepicker';
import { InlineEditorModule } from '@qontu/ngx-inline-editor';
import { NgSelectModule } from '@ng-select/ng-select';
import { DropdownsModule } from '../dropdowns/dropdowns.module';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { CompanyService } from '../../features/companies/company.service';
import { ProjectService } from '../../features/projects/project.service';
import { PurchaseService } from '../../features/projects/purchase.service';
import { EventService } from '../../features/events/event.service';
import { DataTableModule } from 'angular2-datatable';
import { RouterModule } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DropdownsModule,
    SweetAlert2Module,
    BsDatepickerModule,
    NgSelectModule,
    AngularMultiSelectModule,
    NgxPaginationModule,
    AngularDateTimePickerModule,
    InlineEditorModule,
    NgxSmartModalModule,
    DataTableModule
  ],
  providers: [
    TaskService,
    CompanyService,
    ProjectService,
    PurchaseService,
    EventService
  ],
  declarations: [
    TasksListComponent,
    CreateTaskComponent
  ],
  exports: [
    TasksListComponent,
    CreateTaskComponent
  ]
})
export class TaskModule { }



// WEBPACK FOOTER //
// ./client/app/shared/tasks/task.module.ts